(function () {
  "use strict";

  var DEFAULTS = {
    endpoint: "/apps/b2b-submit-order/create-draft",
    buttonSelector:
      "[data-b2b-submit-order], [data-b2b-submit-order] *, [data-order-request-button], [data-order-request-button] *",
    statusSelector: "[data-b2b-submit-order-status], #cart-errors",
    rootSelector: "[data-b2b-submit-order-root]",
    poRequiredFormSelector: "form[action='/cart'], form#cart, form[name='cart']",
    poInputCandidates: [
      "#CartPurchaseOrderNumber",
      'input[name="attributes[Purchase Order Number]"]'
    ],
    poAttributeKey: "Purchase Order Number",
    clearCartOnSuccess: true,
    reloadOnSuccess: false,
    successReloadDelay: 500,
    successRedirectUrl: "/cart?approval_submitted=1",
    reviewRedirectOnSuccess: false,
    blockNativeCheckoutWhenPoRequired: true
  };

  function $(selector, context) {
    return (context || document).querySelector(selector);
  }

  function $$(selector, context) {
    return Array.prototype.slice.call(
      (context || document).querySelectorAll(selector)
    );
  }

  function trim(value) {
    return typeof value === "string" ? value.replace(/^\s+|\s+$/g, "") : "";
  }

  function normalizeBoolean(value, fallback) {
    if (value === true || value === "true" || value === "1") return true;
    if (value === false || value === "false" || value === "0") return false;
    return fallback;
  }

  function getRoot(button) {
    return button.closest(DEFAULTS.rootSelector) || document;
  }

  function getConfig(button) {
    var root = getRoot(button);
    var globalConfig = window.__B2BSubmitOrderConfig || {};

    return {
      endpoint:
        button.getAttribute("data-endpoint") ||
        (root !== document ? root.getAttribute("data-endpoint") : "") ||
        globalConfig.endpoint ||
        DEFAULTS.endpoint,

      shop:
        button.getAttribute("data-shop") ||
        (root !== document ? root.getAttribute("data-shop") : "") ||
        globalConfig.shop ||
        getShopDomain(),

      loggedInCustomerId:
        button.getAttribute("data-logged-in-customer-id") ||
        (root !== document
          ? root.getAttribute("data-logged-in-customer-id")
          : "") ||
        globalConfig.loggedInCustomerId ||
        readCustomerIdFromPage(),

      clearCartOnSuccess: normalizeBoolean(
        button.getAttribute("data-clear-cart-on-success") ||
          (root !== document
            ? root.getAttribute("data-clear-cart-on-success")
            : "") ||
          globalConfig.clearCartOnSuccess,
        DEFAULTS.clearCartOnSuccess
      ),

      reloadOnSuccess: normalizeBoolean(
        button.getAttribute("data-reload-on-success") ||
          (root !== document
            ? root.getAttribute("data-reload-on-success")
            : "") ||
          globalConfig.reloadOnSuccess,
        DEFAULTS.reloadOnSuccess
      ),

      reviewRedirectOnSuccess: normalizeBoolean(
        button.getAttribute("data-review-redirect-on-success") ||
          (root !== document
            ? root.getAttribute("data-review-redirect-on-success")
            : "") ||
          globalConfig.reviewRedirectOnSuccess,
        DEFAULTS.reviewRedirectOnSuccess
      ),

      successRedirectUrl:
        trim(
          button.getAttribute("data-success-redirect-url") ||
            (root !== document
              ? root.getAttribute("data-success-redirect-url")
            : "") ||
            globalConfig.successRedirectUrl ||
            DEFAULTS.successRedirectUrl
        ),

      successReloadDelay:
        Number(
          button.getAttribute("data-success-reload-delay") ||
            (root !== document
              ? root.getAttribute("data-success-reload-delay")
            : "") ||
            globalConfig.successReloadDelay
        ) || DEFAULTS.successReloadDelay,

      blockNativeCheckoutWhenPoRequired: normalizeBoolean(
        button.getAttribute("data-block-native-checkout") ||
          (root !== document
            ? root.getAttribute("data-block-native-checkout")
          : "") ||
          globalConfig.blockNativeCheckoutWhenPoRequired,
        DEFAULTS.blockNativeCheckoutWhenPoRequired
      )
    };
  }

  function getShopDomain() {
    if (window.Shopify && window.Shopify.shop) {
      return window.Shopify.shop;
    }

    var metaShop = $('meta[name="shopify-shop-domain"]');
    if (metaShop && metaShop.content) return metaShop.content;

    return window.location.hostname;
  }

  function readCustomerIdFromPage() {
    var explicitInput =
      $('input[name="loggedInCustomerId"]') ||
      $('input[name="customerId"]') ||
      $('input[data-logged-in-customer-id]');

    if (explicitInput) {
      var explicitValue =
        explicitInput.value ||
        explicitInput.getAttribute("data-logged-in-customer-id");
      if (trim(explicitValue)) return trim(explicitValue);
    }

    var metaCustomer = $('meta[name="shopify-customer-id"]');
    if (metaCustomer && trim(metaCustomer.content)) {
      return trim(metaCustomer.content);
    }

    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page &&
      window.ShopifyAnalytics.meta.page.customerId
    ) {
      return String(window.ShopifyAnalytics.meta.page.customerId);
    }

    return "";
  }

  function getPurchaseOrderInput(root) {
    var candidates = DEFAULTS.poInputCandidates;
    for (var i = 0; i < candidates.length; i++) {
      var field = $(candidates[i], root || document);
      if (field && typeof field.value === "string") return field;
    }
    return null;
  }

  function getPoErrorElement() {
    return $("[data-po-error]");
  }

  function getStatusElement(root) {
    var status = $(DEFAULTS.statusSelector, root);
    if (status) return status;

    status = document.createElement("div");
    status.setAttribute("data-b2b-submit-order-status", "");
    status.style.marginTop = "12px";
    status.style.fontSize = "14px";

    if (root !== document && root.appendChild) {
      root.appendChild(status);
    } else {
      document.body.appendChild(status);
    }

    return status;
  }

  function getStatusLinksElement(root) {
    var links = $("[data-b2b-submit-order-status-links]", root);
    if (links) return links;

    var status = getStatusElement(root);
    links = document.createElement("div");
    links.setAttribute("data-b2b-submit-order-status-links", "");
    links.style.marginTop = "8px";
    links.style.display = "flex";
    links.style.flexWrap = "wrap";
    links.style.gap = "12px";
    links.style.fontSize = "14px";

    if (status.parentNode) {
      status.parentNode.insertBefore(links, status.nextSibling);
    } else if (root !== document && root.appendChild) {
      root.appendChild(links);
    } else {
      document.body.appendChild(status);
      document.body.appendChild(links);
    }

    return links;
  }

  function clearStatusLinks(root) {
    var links = getStatusLinksElement(root);
    links.innerHTML = "";
  }

  function setStatus(root, type, message) {
    var el = getStatusElement(root);
    el.textContent = message || "";

    el.style.color =
      type === "error"
        ? "#b42318"
        : type === "success"
        ? "#067647"
        : "#344054";

    if (type !== "success") {
      clearStatusLinks(root);
    }
  }

  function setStatusLinks(root, items) {
    var el = getStatusLinksElement(root);
    el.innerHTML = "";

    (items || []).forEach(function (item) {
      if (!item || !trim(item.href) || !trim(item.label)) return;

      var link = document.createElement("a");
      link.href = item.href;
      link.textContent = item.label;
      link.target = item.target || "_self";
      link.rel = item.target === "_blank" ? "noopener" : "";
      link.style.color = "#175cd3";
      link.style.textDecoration = "underline";
      el.appendChild(link);
    });
  }

  function setButtonBusy(button, busy, busyText) {
    if (!button) return;

    if (!button.__originalText) {
      button.__originalText = button.textContent;
    }

    button.disabled = !!busy;
    button.setAttribute("aria-busy", busy ? "true" : "false");
    button.style.opacity = busy ? "0.6" : "";

    if (busy && busyText) {
      button.textContent = busyText;
    } else if (!busy && button.__originalText) {
      button.textContent = button.__originalText;
    }
  }

  function showPoFieldError(input, show) {
    if (!input) return;
    if (show) {
      input.setAttribute("aria-invalid", "true");
      var err = getPoErrorElement();
      if (err) {
        err.hidden = false;
        err.textContent = "Purchase order number is required.";
      }
    } else {
      input.removeAttribute("aria-invalid");
      var err = getPoErrorElement();
      if (err) err.hidden = true;
    }
  }

  function getCurrentPoValue(root) {
    var input = getPurchaseOrderInput(root);
    if (!input) return "";
    return trim(input.value);
  }

  function isPoRequiredForCustomer(root) {
    var wrapper = $("[data-po-required-field]", root || document);
    if (!wrapper) return false;
    var value = wrapper.getAttribute("data-po-required");
    return value === "true" || value === "1" || value === "yes";
  }

  function findCartForm() {
    var form = $(DEFAULTS.poRequiredFormSelector);
    if (form) return form;

    // Fallback: any form whose action points at /cart (the native Shopify
    // cart form, the cart drawer form, or a dynamically-mounted form).
    var forms = $$("form[action]");
    for (var i = 0; i < forms.length; i++) {
      var action = forms[i].getAttribute("action") || "";
      if (action.indexOf("/cart") === 0) return forms[i];
    }
    return null;
  }

  function syncCartPoAttribute(value) {
    var attributes = {};
    attributes[DEFAULTS.poAttributeKey] = value;

    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to write PO attribute to cart");
      }
      return response.json();
    });
  }

  function normalizeCartAttributes(attributes, purchaseOrderNumber) {
    var result = [];
    if (!attributes || typeof attributes !== "object") attributes = {};

    Object.keys(attributes).forEach(function (key) {
      var value = attributes[key];
      if (value === null || value === undefined) return;
      if (!trim(String(key)) || !trim(String(value))) return;
      // Drop the canonical PO key from the duplicate carrier list. The PO is
      // the single source of truth and goes out as `purchaseOrderNumber`.
      if (trim(String(key)).toLowerCase() === "purchase order number") return;
      if (trim(String(key)).toLowerCase() === "po number") return;
      if (trim(String(key)).toLowerCase() === "ponumber") return;
      if (trim(String(key)).toLowerCase() === "purchaseordernumber") return;
      result.push({ key: String(key), value: String(value) });
    });

    return result;
  }

  function normalizeCartLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items
      .map(function (item) {
        if (!item || !item.variant_id || !item.quantity) return null;
        return {
          variantId: String(item.variant_id),
          quantity: Number(item.quantity) || 1,
          title: item.product_title || item.title || "",
          variantTitle: item.variant_title || "",
          sku: item.sku || ""
        };
      })
      .filter(Boolean);
  }

  function fetchCart() {
    return fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to read cart");
      return response.json();
    });
  }

  function clearCart() {
    return fetch("/cart/clear.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({})
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to clear cart");
      return response.json();
    });
  }

  function buildRequestPayload(cart, root, config) {
    // Single source of truth: the PO input on the cart page.
    var purchaseOrderNumber = getCurrentPoValue(root);

    // Strip the PO from attributes (the cart attribute and the explicit
    // purchaseOrderNumber key must not be sent twice).
    var sanitizedAttributes = normalizeCartAttributes(
      cart && cart.attributes ? cart.attributes : {},
      purchaseOrderNumber
    );

    return {
      lines: normalizeCartLines(cart),
      purchaseOrderNumber: purchaseOrderNumber,
      cartToken: cart && cart.token ? String(cart.token) : "",
      loggedInCustomerId: config.loggedInCustomerId || "",
      attributes: sanitizedAttributes
    };
  }

  function submitDraft(config, payload) {
    var url = new URL(config.endpoint, window.location.origin);

    if (config.shop) url.searchParams.set("shop", config.shop);
    if (config.loggedInCustomerId) {
      url.searchParams.set("logged_in_customer_id", config.loggedInCustomerId);
    }

    return fetch(url.toString(), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.text().then(function (text) {
        var parsed;
        try {
          parsed = JSON.parse(text);
        } catch (error) {
          console.error("Non-JSON create-draft response:", {
            status: response.status,
            url: response.url,
            body: text
          });
          return {
            ok: false,
            error: "Non-JSON response from submit-order endpoint",
            status: response.status,
            rawBody: text
          };
        }

        if (!response.ok && parsed && !parsed.error) {
          parsed.error = "Request failed with HTTP " + response.status;
        }

        return parsed;
      });
    });
  }

  function dispatchEvent(name, detail) {
    document.dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail: detail || {} })
    );
  }

  function getReviewUrl(result) {
    if (result && typeof result.reviewUrl === "string" && trim(result.reviewUrl)) {
      return trim(result.reviewUrl);
    }
    return "";
  }

  function getInvoiceUrl(result) {
    if (
      result &&
      result.draftOrder &&
      typeof result.draftOrder.invoiceUrl === "string" &&
      trim(result.draftOrder.invoiceUrl)
    ) {
      return trim(result.draftOrder.invoiceUrl);
    }
    if (result && typeof result.invoiceUrl === "string" && trim(result.invoiceUrl)) {
      return trim(result.invoiceUrl);
    }
    return "";
  }

  function handleSuccess(root, button, config, result) {
    var message =
      result && result.successMessage
        ? result.successMessage
        : "Your order has been submitted for approval.";

    var reviewUrl = getReviewUrl(result);
    var invoiceUrl = getInvoiceUrl(result);

    window.__lastB2BSubmitOrderResult = result || null;

    setStatus(root, "success", message);
    dispatchEvent("b2b:submit-order:success", result || {});

    var cartWasCleared = false;
    var afterSuccess = Promise.resolve();

    if (config.clearCartOnSuccess) {
      afterSuccess = afterSuccess.then(function () {
        return clearCart()
          .then(function () {
            cartWasCleared = true;
            dispatchEvent("b2b:submit-order:cart-cleared", result || {});
          })
          .catch(function (error) {
            console.warn("B2B submit order: cart clear failed", error);
          });
      });
    }

    afterSuccess.then(function () {
      if (reviewUrl) {
        console.info(
          "B2B submit order: reviewUrl returned for approver workflow only.",
          reviewUrl
        );
      } else {
        console.warn(
          "B2B submit order succeeded but no reviewUrl was returned by the backend.",
          result
        );
      }

      if (config.successRedirectUrl) {
        window.location.assign(config.successRedirectUrl);
        return;
      }

      if (config.reloadOnSuccess || cartWasCleared) {
        window.setTimeout(function () {
          window.location.reload();
        }, config.successReloadDelay);
      }
    });
  }

  function extractErrorMessage(result) {
    if (!result) return "Unable to submit order.";

    if (result.error) return result.error;

    if (Array.isArray(result.userErrors) && result.userErrors.length) {
      return result.userErrors
        .map(function (item) {
          return item && item.message ? item.message : "";
        })
        .filter(Boolean)
        .join(" | ");
    }

    return "Unable to submit order.";
  }

  function handleSubmit(button) {
    var root = getRoot(button);
    var config = getConfig(button);

    clearStatusLinks(root);
    setStatus(root, "info", "");

    if (!config.shop) {
      setStatus(root, "error", "Missing shop domain.");
      return;
    }

    if (!config.loggedInCustomerId) {
      setStatus(
        root,
        "error",
        "Missing logged-in customer ID. Add data-logged-in-customer-id to the submit button or wrapper."
      );
      return;
    }

    // Single source of truth: the PO input. If PO is required for this
    // customer's company location and the input is empty, block before
    // firing either /cart/update.js or the create-draft endpoint.
    var poInput = getPurchaseOrderInput(root);
    var poRequired = isPoRequiredForCustomer(root);
    var poValue = getCurrentPoValue(root);

    if (poRequired && poValue.length === 0) {
      showPoFieldError(poInput, true);
      var statusEl = getStatusElement(root);
      statusEl.textContent = "Purchase order number is required.";
      statusEl.style.color = "#b42318";
      dispatchEvent("b2b:submit-order:error", {
        error: new Error("Purchase order number is required."),
        field: "purchaseOrderNumber"
      });
      return;
    }

    showPoFieldError(poInput, false);

    setButtonBusy(button, true, "Submitting...");

    fetchCart()
      .then(function () {
        // Persist the PO to the cart before posting the draft, so the
        // native cart state and the draft we send to the proxy agree.
        // Skip the round-trip if the value is already identical to what
        // /cart.js reported previously in this session.
        return syncCartPoAttribute(poValue).catch(function (error) {
          console.warn(
            "B2B submit order: /cart/update.js PO sync failed; continuing.",
            error
          );
          return null;
        });
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        var lines = normalizeCartLines(cart);
        if (!lines.length) throw new Error("Your cart is empty.");
        var payload = buildRequestPayload(cart, root, config);
        return submitDraft(config, payload);
      })
      .then(function (result) {
        if (!result || result.ok !== true) {
          // Surface a server-side PO-block into the inline error + status.
          if (
            result &&
            result.field === "purchaseOrderNumber" &&
            poInput
          ) {
            showPoFieldError(poInput, true);
          }
          throw new Error(extractErrorMessage(result));
        }

        console.log("B2B create-draft result:", result);
        handleSuccess(root, button, config, result);
      })
      .catch(function (error) {
        console.error("B2B submit order failed:", error);
        setStatus(
          root,
          "error",
          error && error.message
            ? error.message
            : "Something went wrong while submitting the order."
        );
        dispatchEvent("b2b:submit-order:error", { error: error });
      })
      .finally(function () {
        setButtonBusy(button, false);
      });
  }

  function onDocumentClick(event) {
    var button = event.target.closest(DEFAULTS.buttonSelector);
    if (!button) return;

    // For nested matches against `[data-b2b-submit-order] *`, walk up to
    // the element carrying the attribute so the click is attributed to the
    // button itself, not a child like an icon span.
    if (!button.hasAttribute("data-b2b-submit-order") &&
        !button.hasAttribute("data-order-request-button")) {
      var host = button.closest("[data-b2b-submit-order], [data-order-request-button]");
      if (host) button = host;
    }

    event.preventDefault();
    handleSubmit(button);
  }

  // ── Native checkout interception ─────────────────────────────────────
  // When the buyer's company location sets po_required, the native cart
  // submit (and Shopify's wallet-block buttons) must NOT bypass the
  // approval workflow. We bind to the cart form's submit event with
  // capture:true so we run before any other listener.
  function blockNativeCheckoutIfNeeded(event) {
    if (!isPoRequiredForCustomer(document)) return;
    var root = document;
    var poInput = getPurchaseOrderInput(root);
    var poValue = getCurrentPoValue(root);
    if (poValue.length > 0) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    showPoFieldError(poInput, true);
    var statusEl = getStatusElement(root);
    if (statusEl) {
      statusEl.textContent = "Purchase order number is required.";
      statusEl.style.color = "#b42318";
    }
    dispatchEvent("b2b:submit-order:error", {
      error: new Error("Purchase order number is required."),
      field: "purchaseOrderNumber"
    });

    if (poInput && typeof poInput.focus === "function") {
      try { poInput.focus(); } catch (e) { /* no-op */ }
    }

    if (event.target && typeof event.target.scrollIntoView === "function") {
      try { event.target.scrollIntoView({ block: "center" }); } catch (e) { /* no-op */ }
    }
    return false;
  }

  function bindCartFormGuard() {
    var form = findCartForm();
    if (!form || form.__b2bPoFormBind) return;
    form.__b2bPoFormBind = true;
    form.addEventListener("submit", blockNativeCheckoutIfNeeded, {
      capture: true,
      passive: false
    });
  }

  function bindCheckoutButtons() {
    // Shopify renders dynamic wallet / checkout buttons via
    // `dynamic_checkout_cart_buttons` (or via `[id$="checkout"]`). When
    // a buyer clicks them, Shopify proceeds directly to /checkout. We
    // intercept at click time so the same PO gate runs. Buttons under
    // [data-b2b-submit-order] are B2B-only and already handled by the
    // primary click listener, so we skip them here.
    var candidates = $$("button.checkout, button[name='checkout'], #checkout, [name='checkout'], button[type='submit'][form='cart']");
    candidates.forEach(function (btn) {
      if (!btn || btn.__b2bPoCheckoutBind) return;
      if (btn.closest("[data-b2b-submit-order]")) return;
      btn.__b2bPoCheckoutBind = true;
      btn.addEventListener("click", function (event) {
        if (!isPoRequiredForCustomer(document)) return;
        var poValue = getCurrentPoValue(document);
        if (poValue.length > 0) return;

        event.preventDefault();
        event.stopPropagation();
        var poInput = getPurchaseOrderInput(document);
        showPoFieldError(poInput, true);
        var statusEl = getStatusElement(document);
        if (statusEl) {
          statusEl.textContent = "Purchase order number is required.";
          statusEl.style.color = "#b42318";
        }
        dispatchEvent("b2b:submit-order:error", {
          error: new Error("Purchase order number is required."),
          field: "purchaseOrderNumber"
        });
        if (poInput && typeof poInput.focus === "function") {
          try { poInput.focus(); } catch (e) { /* no-op */ }
        }
      }, { capture: true, passive: false });
    });
  }

  function rebindAllGuards() {
    bindCartFormGuard();
    bindCheckoutButtons();
  }

  function init() {
    document.addEventListener("click", onDocumentClick, false);

    if (DEFAULTS.blockNativeCheckoutWhenPoRequired) {
      bindCartFormGuard();
      bindCheckoutButtons();

      // The cart section is re-rendered whenever a line is added/removed
      // and on `cart:updated`. Re-bind guards after every re-render.
      document.addEventListener("cart:updated", rebindAllGuards, false);
      document.addEventListener("sections:loaded", rebindAllGuards, false);
      document.addEventListener("cart-section-rendered", rebindAllGuards, false);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, false);
  } else {
    init();
  }
})();
